/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { InvitationResult } from './invitationResult';

/**
 * Serializer for bulk invite response.
 */
export interface BulkInviteResponse { 
    /**
     * Výsledky jednotlivých pozvánek
     */
    results: Array<InvitationResult>;
    /**
     * Celkový počet pozvánek
     */
    total: number;
    /**
     * Počet úspěšných pozvánek
     */
    successful: number;
    /**
     * Počet neúspěšných pozvánek
     */
    failed: number;
}